import { useContext } from 'react'
import { Row } from 'reactstrap'
import { useProjectGeneralFormSelectOptions } from '../../pages/Projects/hooks'
import AppPermissionsSwitcher from '../AppPermissionsSwitcher/AppPermissionsSwitcher'
import FormMainContainer from '../Common/FormMainContainer'
import FormSideContainer from '../Common/FormSideContainer'
import RecursiveForm from '../RecursiveForm'
import ProjectFormGeneralContext from './ProjectFormGeneralContext'

const ProjectFormGeneralTab = (props) => {
    const { children, formik, inputs, subform, tabs, activeTab, handleTabChange, module, owner } = props

    const { selectOptions, isPending: selectOptionsLoading } = useProjectGeneralFormSelectOptions(owner)

    return (
        <ProjectFormGeneralContext.Provider
            value={{
                formik,
                inputs,
                subform,
                tabs,
                activeTab,
                handleTabChange,
                module,
                selectOptions,
                selectOptionsLoading,
            }}
        >
            <Row>{children}</Row>
        </ProjectFormGeneralContext.Provider>
    )
}

export const ProjectFormGeneralTabSide = () => {
    const { inputs, formik, subform, selectOptions, selectOptionsLoading, module } = useContext(ProjectFormGeneralContext)

    return (
        <FormSideContainer>
            <AppPermissionsSwitcher permission="EditData" data={inputs?.sideForm} module={module}>
                {({ newData }) => (
                    <RecursiveForm
                        inputs={newData}
                        subform={subform}
                        formik={formik}
                        selectOptions={selectOptions}
                        selectOptionsLoading={selectOptionsLoading}
                    />
                )}
            </AppPermissionsSwitcher>
        </FormSideContainer>
    )
}

export const ProjectFormGeneralTabMain = () => {
    const { inputs, formik, subform, selectOptions, selectOptionsLoading, tabs, activeTab, handleTabChange, module } =
        useContext(ProjectFormGeneralContext)

    return (
        <FormMainContainer tabs={tabs} activeTab={activeTab} handleTabChange={handleTabChange} formik={formik}>
            <AppPermissionsSwitcher permission="EditData" data={inputs?.mainForm} module={module}>
                {({ newData }) => (
                    <RecursiveForm
                        inputs={newData}
                        subform={subform}
                        formik={formik}
                        selectOptions={selectOptions}
                        selectOptionsLoading={selectOptionsLoading}
                    />
                )}
            </AppPermissionsSwitcher>
        </FormMainContainer>
    )
}

export default ProjectFormGeneralTab
